import React, { useState } from 'react';
import {
  Hamburger,
  HamburgerLine,
  NavBrand,
  NavBrandText,
  NavCta,
  NavItem,
  NavLogo,
  NavMenu,
  NavWrapper,
  SiteHeader,
  TopBar,
  TopBarLinks,
  TopBarText,
} from './styled/navbar.style';
import { NavLink as RouterNavLink } from 'react-router-dom';
import logo from './images/kmkupscale.jpg';
import { business } from './siteData';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen((current) => !current);
  };

  const closeNav = () => {
    setIsOpen(false);
  };

  return (
    <SiteHeader>
      <TopBar>
        <TopBarText>Serving {business.serviceArea}</TopBarText>
        <TopBarLinks>
          <a href={business.phoneHref}>{business.phoneDisplay}</a>
          <a href={business.emailHref}>{business.email}</a>
        </TopBarLinks>
      </TopBar>
      <NavWrapper aria-label="Primary navigation">
        <NavBrand to="/" onClick={closeNav} aria-label="KMK Drywall home">
          <NavLogo src={logo} alt="KMK Drywall logo" />
          <NavBrandText>
            <strong>{business.name}</strong>
            <span>Drywall Contractor</span>
          </NavBrandText>
        </NavBrand>
        <Hamburger
          aria-controls="site-navigation"
          aria-expanded={isOpen}
          aria-label="Toggle navigation menu"
          onClick={toggleNav}
          type="button"
        >
          <HamburgerLine isOpen={isOpen} />
          <HamburgerLine isOpen={isOpen} />
          <HamburgerLine isOpen={isOpen} />
        </Hamburger>
        <NavMenu id="site-navigation" isOpen={isOpen}>
          <NavItem>
            <RouterNavLink to="/" onClick={closeNav}>
              Home
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/about" onClick={closeNav}>
              About
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <NavCta to="/quote" onClick={closeNav}>
              Request a Quote
            </NavCta>
          </NavItem>
        </NavMenu>
      </NavWrapper>
    </SiteHeader>
  );
};

export default Navbar;
